import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './daily_demand_report.routes';
import DemandPowerService from '../../../components/api/demand_power/demand_power.service';
import WeatherService from '../../../components/api/weather/weather.service';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import CompareWeatherLogic from '../../../components/logic/compare_weather/compare_weather.logic';
import PowerFormatter from '../../../components/logic/power-formatter/power-formatter.logic';
import chartConfig from './daily_demand_report.config';

export class DailyDemandReportController {
  /*@ngInject*/
  constructor($stateParams, $q, $filter, $interval, moment, DemandPowerService, DateUtil, CsvUtil, WeatherService, CompareWeatherLogic, PowerFormatter) {
    this.id = $stateParams.id;
    this.$q = $q;
    this.$filter = $filter;
    this.interval = $interval;
    this.DemandPowerService = DemandPowerService;
    this.WeatherService = WeatherService;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.CsvUtil = CsvUtil;
    this.CompareWeatherLogic = CompareWeatherLogic;

    this.categories = DateUtil.getXLabels; // ['00:30', '00:30', ... '00:00']
    this.today = this.moment().startOf('day').toDate();
    this.targetDate = $stateParams.target || this.today;
    $stateParams.target = null;

    this.maxDate = this.today;
    this.missingTimes = [];

    this.downloadFileName = 'demand_power.csv';

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.parentComponent.saConfigPromise.then(config => {
      let contract_powers = [];
      let limit_powers = [];
      let target_powers = [];
      for (let i = 0; i < 48; i++) {
        contract_powers.push(config.contract_power);
        limit_powers.push(config.limit_power);
        target_powers.push(config.target_power);
      }

      this.chart.series[1].setData(target_powers, false);
      this.chart.series[2].setData(limit_powers, false);
      this.chart.series[3].setData(contract_powers, false);
    });

    this.updateGraph(this.targetDate);

    this.timer = this.interval(() => {
      this.updateGraph(this.targetDate);
    }, 300000);
  }

  updateGraph(targetDate) {
    const dateQuery = this.DateUtil.getQueryParams(targetDate);

    this.$q.all([
      this.DemandPowerService.show(angular.extend({id: this.id}, dateQuery)).$promise,
      this.WeatherService.api.index(angular.extend({sa_config_id: this.id}, dateQuery)).$promise
    ]).then(responses => {
      [this.demandPowers, this.missingTimes] = this.PowerFormatter.formatDemandPowers(responses[0].powers, targetDate, this.categories);

      const weathers = this.setWeather(responses[1]);

      this.csvData = this.CsvUtil.processDemandPower(this.demandPowers, this.categories, this.targetDate, this.missingTimes, weathers);
      this.downloadFileName = this.moment(targetDate).format('[demand_power_]YYYY-MM-DD[.csv]');

      this.chart.series[0].setData(this.demandPowers);
      this.chart.reflow();
      this.maxPower = Math.max.apply(null, this.demandPowers);
    });
  }

  isMissingTime(time) {
    return this.missingTimes.indexOf(time) !== -1
  }

  changeDate(diff) {
    if (diff !== undefined) {
      this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
    }

    this.updateGraph(this.targetDate);
  }

  $onDestroy() {
    if (this.timer) {
      this.interval.cancel(this.timer);
    }
  }

  setWeather(weathers) {
    const weatherSamplingInterval = ['03:00', '09:00', '15:00', '21:00'];

    this.weathers = this.CompareWeatherLogic.compareHourly(weathers, weatherSamplingInterval);
    const y = this.weathers.length > 0 ? 46 : null;
    this.chart.xAxis[0].update({
      labels: {y: y}
    }, false);

    this.chart.redraw(false);

    return this.weathers;
  }
}


export default angular.module('leptonApp.dailyDemandReport', [uiRouter, DemandPowerService, Chart, DateUtil, CsvUtil, moment, WeatherService, CompareWeatherLogic, PowerFormatter])
  .config(routing)
  .component('dailyDemandReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./daily_demand_report.html'),
    controller: DailyDemandReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/daily/daily_demand_report.component.js